import {useEffect} from 'react';
import {useDeviceId} from '@/hooks';

export const DeviceInit = () => {
  const {generateDeviceId} = useDeviceId();

  useEffect(() => {
    generateDeviceId();
  }, [generateDeviceId]);

  return null;
};
